"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "170.08",
    height: "170.08",
    viewBox: "0 0 170.08 170.08",
    fill: "#004865"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "67.44",
    y: "47.27",
    width: "35.2",
    height: "35.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.4,82.08a35.24,35.24,0,0,1,4.12-5A35.24,35.24,0,0,0,108.4,82.08Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.34,64a36.79,36.79,0,0,1,26.27,11,21.24,21.24,0,0,0,2.61-10.15A21.58,21.58,0,0,0,143.66,43.3H26.43a21.56,21.56,0,0,0-3.89,42.77c.25,0,.48-.07.73-.07a12.43,12.43,0,0,1,3.12.44H45.57a11.32,11.32,0,0,1,6.25,0h50.57A37,37,0,0,1,136.34,64Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M102.65,100.81h0a.31.31,0,0,0,0,.1,33.56,33.56,0,0,0,5.76,18.83,33.56,33.56,0,0,1-5.76-18.83S102.65,100.84,102.65,100.81Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.4,82.08A33.83,33.83,0,0,0,106,86.44h0A33.83,33.83,0,0,1,108.4,82.08Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.34,67.21h0a33.48,33.48,0,0,1,17.74,5.1A33.48,33.48,0,0,0,136.34,67.21Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.86,91.18c-.6,0-1.19-.09-1.78-.16a7.52,7.52,0,1,0,1.78.16Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.55,91.26h-3.7a7.55,7.55,0,1,0,3.7,0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M112.52,124.73a35.24,35.24,0,0,1-4.12-5A35.24,35.24,0,0,0,112.52,124.73Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.82,86.44a11.32,11.32,0,0,0-6.25,0H26.39A12.43,12.43,0,0,0,23.27,86c-.25,0-.48.06-.73.07A21.56,21.56,0,0,1,26.43,43.3H143.66a21.58,21.58,0,0,1,21.56,21.57A21.24,21.24,0,0,1,162.61,75a37.48,37.48,0,0,1,3.32,3.91A26.11,26.11,0,0,0,170,64.87a26.42,26.42,0,0,0-26.38-26.39H131.37v-2A2.41,2.41,0,0,0,129,34H115.12a2.41,2.41,0,0,0-2.41,2.41v2H53.92v-2A2.41,2.41,0,0,0,51.51,34H37.66a2.4,2.4,0,0,0-2.4,2.41v2H26.43a26.37,26.37,0,0,0-11,50.34A12.49,12.49,0,0,0,14.16,90H5.87a2.52,2.52,0,0,0-2.52,2.52s0,0,0,.06,0,0,0,0A2.41,2.41,0,0,0,5.76,95h5.52a12.41,12.41,0,0,0-.58,3.57,12.57,12.57,0,0,0,25.13,0,12.41,12.41,0,0,0-2.39-7.3h5.08a12.41,12.41,0,0,0-2.39,7.3A12.55,12.55,0,0,0,61,100.81h38.4a36.81,36.81,0,0,1,3-14.37ZM23.27,106.12A7.55,7.55,0,0,1,23.08,91c.59.07,1.18.12,1.78.16a7.56,7.56,0,0,1-1.59,14.94Zm25.43,0a7.54,7.54,0,0,1-1.85-14.86h3.7a7.54,7.54,0,0,1-1.85,14.86Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "136.34",
    cy: "100.91",
    r: "33.7"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153.55,84.33a2.62,2.62,0,0,0-3.69.17l-14.67,16h-14.3a2.61,2.61,0,0,0,0,5.22h15.45a2.6,2.6,0,0,0,1.92-.85L153.71,88a2.57,2.57,0,0,0,.68-1.87A2.64,2.64,0,0,0,153.55,84.33Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;